import React from "react";
import { Helmet } from 'react-helmet-async';

function AboutUs() {
  return (
    <div className="p-8 max-w-4xl mx-auto">
              <Helmet>
                <title>About us</title>
                <meta name="description" content="About us" />
            </Helmet>
      <h1 className="text-3xl font-bold mb-4">About 237Mechanic.com</h1>
      <p className="text-gray-700 mb-4">
      At 237Mechanic, we are committed to being Cameroon’s premier destination for everything automotive. Whether you’re buying a quality second-hand car, sourcing reliable spare parts, or seeking professional servicing and rentals, our goal is to connect you with trusted experts and provide actionable advice. We believe that every vehicle should be a source of comfort, security, and pleasure—and we’re here to help you achieve that with the best products, expert guidance, and a community-driven approach.

Vision:
To empower our customers by offering a seamless, one-stop digital platform where buying, servicing, and maintaining your car is simple, transparent, and affordable.
      </p>
      
    </div>
  );
}

export default AboutUs;
